
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#ABAFB5","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_25476_40367)"}},[_c('path',{attrs:{"d":"M6.528 7.51a2.571 2.571 0 100-5.143 2.571 2.571 0 000 5.143zM11.671 16.08H1.386v-1.142a5.143 5.143 0 0110.286 0v1.143zM11.1 2.367a2.572 2.572 0 010 5.143M12.929 10.012a5.143 5.143 0 013.314 4.8v1.269h-1.714"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_40367"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.814 .652)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    